import { render, staticRenderFns } from "./GroupMonetization.vue?vue&type=template&id=2d5b7472&"
import script from "./GroupMonetization.vue?vue&type=script&lang=js&"
export * from "./GroupMonetization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports